import { view } from '@yola/ws-sdk';
import { COLUMN_WIDTH_ATTRIBUTE } from 'src/js/modules/extensions/registry/ws-column/constants';

const prepareInstructionsForColumnWidthReset = (elementId) => {
  const instructions = {};
  const columns = view.accessors.getLiveElement(elementId);
  const customWidthColumns = columns.querySelectorAll(`ws-column[${COLUMN_WIDTH_ATTRIBUTE}]`);

  if (customWidthColumns.length) {
    customWidthColumns.forEach((column) => {
      const columnId = view.accessors.getLiveElementId(column);
      instructions[columnId] = {
        [COLUMN_WIDTH_ATTRIBUTE]: false,
      };
    });
  }

  return instructions;
};

export default prepareInstructionsForColumnWidthReset;
